<template>
  <Card>
    <img
      src="https://images.ctfassets.net/wmwzystk5o45/48G0OtdrTi83EevqZsw3r3/8e7feeec6d0397cb7d5b50bdff7503ee/Group_10127311_4x.png?fm=avif&w=500&q=100"
      class="w-full h-auto max-w-[317px] mx-auto mb-12"
      alt="Finding care illustration"
    />
    <h1 class="text-h2 font-regular mb-24">Finding care starts here</h1>
    <ul class="text-body font-regular">
      <li class="flex items-center gap-12 pb-32">
        <JobsIcon color="#FF0064" class="flex-shrink-0" />
        <p>Share your needs so we can personalize your results</p>
      </li>
      <li class="flex items-center gap-12 pb-32">
        <AccountOutlineIcon color="#FF0064" class="flex-shrink-0" />
        <p>Explore sitter profiles near you</p>
      </li>
      <li class="flex items-center gap-12 pb-32">
        <MessageSentOutlineIcon color="#FF0064" class="flex-shrink-0" />
        <p>Message sitters you’re interested in to see who’s a good fit</p>
      </li>
    </ul>
    <div class="flex flex-row-reverse mt-8">
      <Button variant="primary" size="medium" class="w-full">Continue</Button>
    </div>
  </Card>
</template>

<script lang="ts">
import Button from '@/components/button/Button.vue';
import Card from '@/components/card/Card.vue';
import AccountOutlineIcon from '@/graphics/icons/AccountOutlineIcon.vue';
import JobsIcon from '@/graphics/icons/JobsIcon.vue';
import MessageSentOutlineIcon from '@/graphics/icons/MessageSentOutlineIcon.vue';

export default {
  name: 'OnboardingSeekerCareNearYou',
  components: { Button, Card, JobsIcon, AccountOutlineIcon, MessageSentOutlineIcon },
  methods: {},
};
</script>
